import {
    PROMOTIONS_FOR_PRIME_SUCCESS,
    PROMOTIONS_FOR_PRIME_LOADING
} from '../actions/PromotionsForPrimeAction';

const initialState = {
    
        promotionsForPrimeData: null,
        isLoading: true
   
};

const PromotionsForPrime = (state = initialState, action = {}) => {

    switch (action.type) {
        case PROMOTIONS_FOR_PRIME_SUCCESS:
            return {
                ...state, promotionsForPrimeData: action.data, isLoading: false
            };
        case PROMOTIONS_FOR_PRIME_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default PromotionsForPrime;
